// extracted by mini-css-extract-plugin
module.exports = {"stickyWrapper":"stickyBottom__stickyWrapper__2Fx","bounceIn":"stickyBottom__bounceIn__3y7","highlightWallMessage":"stickyBottom__highlightWallMessage__2WO"};